import { make } from 'vuex-pathify';

export interface ILayoutState {
  name: 'main' | 'full-screen';
  totalHeight: number | string;
  appBarHeight: number | string;
  contextBarHeight: number | string;
  reportHeight: number | string;
}

const state: ILayoutState = {
  name: 'full-screen',
  totalHeight: 0,
  appBarHeight: 0,
  contextBarHeight: 0,
  reportHeight: 0,
};

const mutations = make.mutations(state);
const getters = make.getters(state);
const actions = make.actions(state);

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
